import CSApi from 'chushi-player'

/**
 * Rem 适配工具
 * 根据屏幕宽度动态计算根元素字体大小，实现响应式布局
 */

// 设计稿宽度
const designWidth = 1920

/**
 * 设置根元素字体大小
 * 使用 100 作为基准，方便计算（1rem = 设计稿宽度/100px）
 */
export function setRem() {
  const docEl = document.documentElement
  const clientWidth = docEl.clientWidth
  const clientHeight = docEl.clientHeight

  // 计算缩放比例，设置根元素字体大小
  // 例如：1920px 设计稿，屏幕宽度 1920px 时，1rem = 100px
  // 屏幕宽度 960px 时，1rem = 50px
  const fontSize = (clientWidth / designWidth) * 100

  docEl.style.fontSize = fontSize + 'px'

  // 获取屏幕分辨率，发送给团安模型进行适配
  CSApi.rtcPlayer.sendMSG({
    type: 'ueCommand',
    name: 'SetResolution',
    data: {
      width: clientWidth,
      height: clientHeight,
    },
  })

  console.log(`屏幕分辨率: ${clientWidth}x${clientHeight}px, 根元素字体大小: ${fontSize}px`)
}

/**
 * 移除 rem 适配
 */
export function removeRem() {
  const docEl = document.documentElement
  docEl.style.fontSize = ''
}

// 初始化
setRem()

// 监听窗口大小变化
let resizeTimer: number | null = null
window.addEventListener('resize', () => {
  // 使用防抖，避免频繁计算
  if (resizeTimer) {
    clearTimeout(resizeTimer)
  }
  resizeTimer = window.setTimeout(() => {
    setRem()
  }, 100)
})

export default {
  setRem,
  removeRem,
}
